import React from 'react';
import {
  DeviceWidth,
  sortDates,
  sortAlpha,
  sortHtml,
  getFormattedDateTime,
} from 'ecs-react-components/dist/index.es';

const htmlCell = (cell) => {
  const markup = () => ({ __html: cell });
  return (
    <div dangerouslySetInnerHTML={markup()} />
  );
};

export const columns = (dispatch, timeZoneAbbr, msgs, language) => {
  const tableColumns = [
    {
      name: msgs.columns.id,
      dataField: 'id',
      hidden: true,
    },
    {
      name: msgs.columns.date,
      dataField: 'date',
      renderField: (cell, row) => {
        const dateParts = getFormattedDateTime(cell, cell, language, true);
        return (
          <div className="text-nowrap">
            { dateParts.datePart } { dateParts.timePart }
            { timeZoneAbbr !== row.timeZoneAbbreviation ? ' ' + row.timeZoneAbbreviation : '' }
          </div>
        );
      },
      columnTitle: true,
      dataSort: true,
      sortFunc: (a, b, direction) => sortDates('date', direction.toUpperCase(), a, b),
    },
    {
      name: msgs.columns.provider,
      dataField: 'provider',
      dataSort: true,
      sortFunc: (a, b, direction) => sortAlpha('provider', direction.toUpperCase(), a, b),
    },
    {
      name: msgs.columns.type,
      dataField: 'type',
      dataSort: true,
      sortFunc: (a, b, direction) => sortAlpha('type', direction.toUpperCase(), a, b),
      maxCollapsedWidth: DeviceWidth.XSmall.maxWidth,
    },
    {
      name: msgs.columns.location,
      dataField: 'location',
      renderField: htmlCell,
      dataSort: true,
      sortFunc: (a, b, direction) => sortHtml('location', direction.toUpperCase(), a, b),
      maxCollapsedWidth: DeviceWidth.XSmall.maxWidth,
    },
    {
      name: msgs.columns.status,
      dataField: 'status',
      dataSort: true,
      sortFunc: (a, b, direction) => sortAlpha('status', direction.toUpperCase(), a, b),
      maxCollapsedWidth: DeviceWidth.XSmall.maxWidth,
    },
  ];

  return tableColumns;
};
